import { http } from "Utils/http";
import { useState, useEffect } from "react";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { store } from 'Store';

const AltProdBatchInProgress = ({ refresh, isPSOPPCAdmin, isVendorLevel3 }) => {
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }

  const handlePendingSftp = (pendingSftp) => {
    if (pendingSftp == "D") {
      return "";
    }

    return "Yes";
  }

  const inProgressAltProdBatchHeader = "Production Data Submission Activity";
  const inProgressAltProdBatchSearchFieldText = "Search by ID";
  const inProgressAltProdBatchSortId = 'submitDate';
  const inProgressAltProdBatchSortOrder = 'desc';

  // Flag: trigger api to reload data
  const [reloadInProgressAltProdBatch, setReloadInProgressAltProdBatch] = useState(false);

  // Set inProgressAltProdBatchSortColumn state; default sort: submitDate desc
  const [inProgressAltProdBatchSortColumn, setInProgressAltProdBatchSortColumn] = useState({
    sortField: "submitDate",
    sortDirection: "desc"
  });

  const [selected, setSelected] = useState(
    {
      allSelected: false,
      selectedCount: 0,
      selectedRows: []
    }
  );

  // Trigger reload InProgressAltProdBatches
  useEffect(() => {
    setReloadInProgressAltProdBatch(refresh);
  }, [refresh]);

  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];

    const nameState = function ({ rowName }) {
      //console.log("print out getListCols", rowName);
      return { id: rowName.id };
    }

    /** PSO ID column will be displayed when PSOPPC Admin or Vendor Level 3 */
    if (isPSOPPCAdmin || isVendorLevel3) {
      listColumns.push(Datatable_Column({ name: "PSO ID", columnName: "psoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }));
    }

    listColumns.push(Datatable_Column({ name: "Alt Batch ID", columnName: "id", selectedRows: selectedList, sortable: true, sortFieldNum: 0, isLink: true, linkData: { title: "", pathname: "/eventDataSubmission/altBatchDetail", text: null, state: nameState }, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "CF Version", columnName: "timePrdCD", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Submission Source", columnName: "submissionSourceCD", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Alt Batch Status", columnName: "batchStatusDesc", selectedRows: selectedList, sortable: true, sortFieldNum: 3, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "In Queue", columnName: "pendingSftp", selectedRows: selectedList, sortable: false, sortFieldNum: 4, formatFunction: handlePendingSftp, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Submission Date", columnName: "submitDate", selectedRows: selectedList, sortable: true, sortFieldNum: 5, formatFunction: handleDateFormat, sortingInfo: sortingInfo }));

    return listColumns;
  }

  const getData = async (filter) => {
    var call = {
      paginationRequest: filter,
      isTestSubmission: "N"
    };

    var url = '/api/alt/inProgressBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": token
      }
    });
  }

  const rowDisabledCriteria = (row) => {
    if (row.batchStatus == "In Progress") {
      return true;
    }
    else {
      return false;
    }
  }

  return (
    <>
      <DatatableBase
        tableClassName="cdaProdInProgressTable"
        rowDisabledCriteria={rowDisabledCriteria}
        reload={reloadInProgressAltProdBatch}
        setReload={setReloadInProgressAltProdBatch}
        getData={getData}
        getListCols={getListCols}
        setSelected={setSelected}
        searchFieldText={inProgressAltProdBatchSearchFieldText}
        datatableHeader={inProgressAltProdBatchHeader}
        datatableDescription={null}
        sortingColumn={inProgressAltProdBatchSortId}
        sortingOrder={inProgressAltProdBatchSortOrder}
      >
      </DatatableBase>
    </>
  )
}

export default AltProdBatchInProgress;